<template>
    <div>
        <div class="grid--lnb __layer-top-tab">
            <div class="gw-lnb">
                <ul>
                    <li v-for="csInfo in csList"
                        :key="'cs'+csInfo.code"
                        :class="{'current':csInfo.code==selCsCode}"
                        @click="csInfoClick(csInfo.code)">
                        <a href="javascript:;"
                           v-text="csInfo.krNm"></a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="layer-content" style="max-height: 614px">
            <component v-if="showAt" v-bind:is="selComponentInfo.componentNm" :params="selComponentInfo.params"></component>
        </div>
        <div class="layer-footer">
            <button class="close" @click="closePopup()"><div class="img-com __layer-del"><span>닫기</span></div></button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cs_popup",
        props:['param'],
        data: function(){
            return {
                showAt:false,
                selCsCode:'001',
                csList: [
                    {code:'001',componentNm:'qstnPopup',krNm:'1:1문의',params:null},
                    {code:'002',componentNm:'noticePopup',krNm:'공지사항',params:null},
                    {code:'003',componentNm:'faqPopup'   ,krNm:'FAQ',params:null},
                ]
            }
        },
        methods: {
            csInfoClick: function(code){
                this.selCsCode = code;
            },
            closePopup: function(){
                this.$store.getters.getComponents.popup.close('csPopup');
            }
        },
        computed: {
            selComponentInfo: function(){
                const _this = this;
                return this.csList.find(function(info){
                    return info.code == _this.selCsCode;
                });
            }
        },
        mounted: function(){
            const _this = this;
            const idx = this.csList.findIndex(function(info){
                return info.code == _this.param.csCode;
            })

            this.csList[idx].params = this.param.csParams;
            this.selCsCode = this.param.csCode;

            this.showAt = true;
        }
    }
</script>

<style scoped>

</style>